// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"4b563c47","598":"1c106716","703":"ff484806","787":"ae0b302d"}[chunkId] + ".chunk.js";
};